export default __webpack_public_path__ + "static/media/2.8563a9b8.png";